export default __webpack_public_path__ + "static/phone2-e155e492e8a02e641f8e8c4d5b24a688.png";